var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74998 4.25009H8.25002V5.74994H6.74998V4.25009ZM6.74998 7.25016H8.25002V11.7501H6.74998V7.25016ZM7.5 0.5C6.01664 0.5 4.56659 0.939867 3.33323 1.76398C2.09986 2.58809 1.13856 3.75943 0.570907 5.12987C0.00324961 6.50032 -0.145275 8.00832 0.144114 9.46318C0.433503 10.918 1.14781 12.2544 2.1967 13.3033C3.2456 14.3522 4.58197 15.0665 6.03682 15.3559C7.49168 15.6453 8.99968 15.4968 10.3701 14.9291C11.7406 14.3614 12.9119 13.4001 13.736 12.1668C14.5601 10.9334 15 9.48336 15 8C14.9993 6.0111 14.2089 4.10386 12.8025 2.69749C11.3961 1.29112 9.48891 0.500716 7.5 0.5ZM7.5 14.0001C6.31343 14.0001 5.1535 13.6483 4.1669 12.9891C3.1803 12.3298 2.41134 11.3928 1.95726 10.2966C1.50318 9.20035 1.38437 7.99406 1.61586 6.83029C1.84735 5.66652 2.41874 4.59752 3.25777 3.75849C4.0968 2.91945 5.1658 2.34806 6.32957 2.11657C7.49335 1.88508 8.69963 2.00389 9.79588 2.45798C10.8921 2.91206 11.8291 3.68102 12.4883 4.66762C13.1476 5.65422 13.4994 6.81415 13.4994 8.00072C13.4971 9.59116 12.8643 11.1158 11.7397 12.2404C10.6151 13.365 9.09045 13.9979 7.5 14.0001Z",
    fill: "#5292D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.76641d4d.svg";
export { ForwardRef as ReactComponent };